module.exports = __webpack_public_path__ + "img/platform7.d66e3506.png";